export const getModifiedNotifications = (notifications = []) => {
  const modifiedNotifications = [];
  let currentGroup = [];

  for (let i = 0; i < notifications?.length; i++) {
    const notification = notifications[i];
    if (notification?.notification_type === 0) {
      currentGroup.push(notification);
      const nextNotification = notifications[i + 1];
      if (nextNotification && nextNotification?.notification_type === 0) {
        continue;
      } else {
        currentGroup?.length === 1
          ? modifiedNotifications?.push(currentGroup[0])
          : modifiedNotifications?.push({
              // keeping the 9999, so that we doesn't encounter any challenge in future
              notification_type: 9999,
              group: currentGroup,
            });
        currentGroup = [];
      }
    } else {
      modifiedNotifications?.push(notification);
    }
  }
  return modifiedNotifications;
};
